/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOrganizationsResponseMeta } from './ListOrganizationsResponseMeta';
import {
    ListOrganizationsResponseMetaFromJSON,
    ListOrganizationsResponseMetaFromJSONTyped,
    ListOrganizationsResponseMetaToJSON,
    ListOrganizationsResponseMetaToJSONTyped,
} from './ListOrganizationsResponseMeta';
import type { Notification } from './Notification';
import {
    NotificationFromJSON,
    NotificationFromJSONTyped,
    NotificationToJSON,
    NotificationToJSONTyped,
} from './Notification';

/**
 * Paginated list of notifications
 * @export
 * @interface ListNotificationsResponse
 */
export interface ListNotificationsResponse {
    /**
     * 
     * @type {Array<Notification>}
     * @memberof ListNotificationsResponse
     */
    notifications: Array<Notification>;
    /**
     * 
     * @type {ListOrganizationsResponseMeta}
     * @memberof ListNotificationsResponse
     */
    meta: ListOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ListNotificationsResponse interface.
 */
export function instanceOfListNotificationsResponse(value: object): value is ListNotificationsResponse {
    if (!('notifications' in value) || value['notifications'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListNotificationsResponseFromJSON(json: any): ListNotificationsResponse {
    return ListNotificationsResponseFromJSONTyped(json, false);
}

export function ListNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListNotificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'notifications': ((json['notifications'] as Array<any>).map(NotificationFromJSON)),
        'meta': ListOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ListNotificationsResponseToJSON(json: any): ListNotificationsResponse {
    return ListNotificationsResponseToJSONTyped(json, false);
}

export function ListNotificationsResponseToJSONTyped(value?: ListNotificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notifications': ((value['notifications'] as Array<any>).map(NotificationToJSON)),
        'meta': ListOrganizationsResponseMetaToJSON(value['meta']),
    };
}

